/**
 * Import required libraries
 */
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { auth as authApi } from "api"
import { connect as socketConnect, getLocalItem, removeLocalItem, useSocketInterrupted } from "Utils"

/**
 * Import required elements
 */
import RoutesRender from "./render"
import { Loading } from "Components"

/**
 * Routes Component
 */
function Routes(props) {
  const {
    authenticated,
    socketConnected,
    navigation
  } = props

  const [logged, setLogged] = useState(false)

  useEffect(() => {
    const tryConnection = async () => {
      try {
        let token = getLocalItem("userToken")
        if (token) {
          if (!authenticated) await authApi.checksession(token)
          if (!global.socket) await socketConnect(token)
        } else throw Error("no token found")
      } catch (err) {
        removeLocalItem("userToken")
        globalThis.store.dispatch({
          type: "UPDATE_NAVIGATION",
          navigation: "login"
        })
      }
    }
    tryConnection()
  }, [authenticated])

  useEffect(() => {
    let _logged = global.socket && Object.keys(global.socket).length && authenticated
    if (_logged !== logged) setLogged(_logged)
  }, [authenticated, logged])

  const socketInterrupted = useSocketInterrupted()
  const socketInitializing = !socketConnected && !socketInterrupted

  if (authenticated && socketInitializing) {
    return <Loading absolute />
  }

  return React.createElement(RoutesRender, {
    logged,
    authenticated,
    navigation,
    socketInterrupted,
  })
}

export default withRouter(connect(state => ({
  navigation: state.window.navigation,
  authenticated: state.user.authenticated,
  socketConnected: state.simtopy.socketConnected,
}))(Routes))